import type { DashboardRowType } from '@shared/types/Dashboard';

export const homeRecordDashboardRows: DashboardRowType[] = [
  {
    items: [
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 3,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 5,
      },
      {
        rowSpan: 1,
        colSpan: 1,
        elementId: 6,
      },
      {
        rowSpan: 2,
        colSpan: 1,
        elementId: 14,
      },
    ],
  },
];
